export const E_COMMERCE_SIGN_IN_PATH = "/ecommerce-store/sign-in/";
export const E_COMMERCE_PRODUCTS_PATH = "/ecommerce-store/products/";
